import {
  ListDealWrappedRequest,
  ListDealWrappedResponse
} from '@spilca/order_ts/v1/order/model_deal_pb';
import { Sorting } from '@spilca/order_ts/v1/order/common_pb';
import { createPagination, FILTER_PARAMS } from '@monorepo/helpers';
import { getGrpcPromise } from '@monorepo/grpc';
import dealsFilterConstructor from '../dealsFilterConstructor';

const dealsWrapperRequestConstructor = (
  filter: any,
  dealService: any
): Promise<ListDealWrappedResponse.AsObject> => {
  const { queryKey, pageParam, pageSize } = filter;
  const [, params] = queryKey;
  const request = new ListDealWrappedRequest();

  const sort = new Sorting();
  sort.setFieldName('created_at');
  sort.setOrder(1);
  request.setSortingList([sort]);

  const dealsFilter = dealsFilterConstructor(params, null);
  const pager = createPagination(
    pageParam || filter[FILTER_PARAMS.page] || 1,
    pageSize
  );
  request.setPagination(pager);
  request.setFilter(dealsFilter);
  return getGrpcPromise(dealService)(request);
};

export default dealsWrapperRequestConstructor;
